// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"aac995a5","638":"eec250f6"}[chunkId] + ".chunk.css";
};